var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.917 1.917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.138,15.65a2.439,2.439,0,0,1-.24,1.045,3.954,3.954,0,0,1-.652.978A4.32,4.32,0,0,1,16.675,18.8a4.812,4.812,0,0,1-1.869.364,7.986,7.986,0,0,1-3.124-.7,16.832,16.832,0,0,1-3.3-1.9,27.552,27.552,0,0,1-3.143-2.683,27.23,27.23,0,0,1-2.674-3.134A17.085,17.085,0,0,1,.69,7.485,8.072,8.072,0,0,1,0,4.351,4.958,4.958,0,0,1,.345,2.5,4.411,4.411,0,0,1,1.447.9,2.808,2.808,0,0,1,3.44,0a1.8,1.8,0,0,1,.776.173,1.562,1.562,0,0,1,.642.537L7.082,3.843a3.28,3.28,0,0,1,.383.671A1.515,1.515,0,0,1,7.6,5.1a1.3,1.3,0,0,1-.2.68,3.26,3.26,0,0,1-.537.68l-.728.757A.513.513,0,0,0,5.98,7.6a.87.87,0,0,0,.029.22c.029.077.057.134.077.192a7.952,7.952,0,0,0,.891,1.227c.431.5.891,1.006,1.39,1.514.517.508,1.016.977,1.524,1.409a7.355,7.355,0,0,0,1.236.882c.048.019.105.048.173.077a.662.662,0,0,0,.24.038.527.527,0,0,0,.393-.163l.728-.719a2.94,2.94,0,0,1,.69-.537,1.276,1.276,0,0,1,.68-.2,1.529,1.529,0,0,1,.585.125,3.706,3.706,0,0,1,.671.374l3.172,2.252a1.454,1.454,0,0,1,.527.613A1.966,1.966,0,0,1,19.138,15.65Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H23V23H0Z",
    fill: "none",
    opacity: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.80255514ab264e65506322b494d1e27e.svg";
export { ForwardRef as ReactComponent };